<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <span class="headline">Clients</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Rechercher un client"
              single-line
              hide-details
              class="mb-4"
            ></v-text-field>
            <v-data-table
              :headers="headers"
              :items="clients"
              :search="search"
              :loading="loading"
              class="elevation-1"
              :items-per-page="15"
              :footer-props="{
                'items-per-page-options': [10, 15, 25, 50, -1]
              }"
            >
              <template v-slot:no-data>
                <v-alert type="info" outlined class="my-4">
                  Aucun client enregistré
                </v-alert>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Clients',
  data() {
    return {
      search: '',
      loading: false,
      headers: [
        { text: 'ID', value: 'id', align: 'start', sortable: true },
        { text: 'Nom', value: 'name', sortable: true },
        { text: 'Type', value: 'client_type', sortable: true },
        { text: 'Ville', value: 'city', sortable: true },
        { text: 'Téléphone', value: 'phone', sortable: false },
      ]
    }
  },
  computed: {
    ...mapGetters(['clients'])
  },
  methods: {
    ...mapActions(['fetchClients']),
    async loadClients() {
      this.loading = true
      try {
        await this.fetchClients()
      } finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    await this.loadClients()
  }
}
</script>

<style scoped>
.v-data-table {
  font-size: 14px;
}
</style>
